import { connect } from 'react-redux';

const mapStateToProps = ({ TrackerData: { trackerLocationsEvent, singleTrackerEvent } }) => ({
  currentEvent: singleTrackerEvent,
  filters: trackerLocationsEvent.filters,
  locationsCanBeShown: !trackerLocationsEvent.loading,
});

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
